import { Injectable } from 'angular-ts-decorators';

import { SpynlBase } from '@shared/app/scripts/services/spynl-base';
import { Domain } from '@shared/app/scripts/services/domain';
import type { IConfig } from '@shared/app/scripts/services/config';
import type { IStandardErrorParser } from '@shared/app/scripts/services/standard-error-parser';

/**
 * Factory in the coreModule. It takes care of communication with playlists
 * resource. Methods are inherited form {@link shared.spynlBase
 * spynlBase} service, and are documented there.
 */
@Injectable('playlist')
export class Playlist extends SpynlBase<Object> {
  location: string;

  constructor(
    public $q: ng.IQService,
    public $http: ng.IHttpService,
    private $translate: ng.translate.ITranslateService,
    public spynlBase: any,
    public standardErrorParser: IStandardErrorParser,
    sentry,
    domain: Domain,
    config: IConfig,
  ) {
    'ngInject';

    super($http, $q, sentry, domain, config, standardErrorParser, Object);
    this.location = '/playlists';
  }

  /**
   * @param {string} tenantId
   * Optional tenantId
   * Creates an empty object for the collection
   * @returns {object} simple, empty playlist
   */
  // TODO SPAPI-699 remove tenantId once the work around will not be necessary
  createNew(tenantId?: string) {
    return {
      active: true,
      name: this.$translate.instant('core.new_playlist'),
      description: '',
      landscape: [],
      portrait: [],
      tenant_id: tenantId ? [tenantId] : undefined,
    };
  }

  /**
   *
   * Try to override the playlist object
   * @param {string} id
   * Id of the object to be updated
   * @param {object} objectToSave
   * Object will be send to save
   * @param {string} tenantId
   * Optional tenantId
   * @returns {promise} it will resolve with success message, or fail with error description
   */
  // TODO SPAPI-342 remove this code, as soon as we don't have to override
  // the spynlBase implementation
  save(id, objectToSave, tenantId?: string) {
    // TODO move to data object itself
    if (!angular.isString(id)) {
      // TODO make text translatable
      return this.$q.reject('The entity id is undefined, not able to save it');
    }

    let tenantSection = '';

    if (angular.isString(tenantId)) {
      tenantSection = '/tenants/' + tenantId;
    }

    return this.$http
      .post(this.getLocation(tenantSection) + '/save', {
        filter: {
          _id: id,
        },
        data: objectToSave,
      })
      .catch(this.standardErrorParser)
      .then((response: any) => response.data.data)
      .catch((error) => this.$q.reject(error.data.message));
  }
}
